module.exports = __webpack_public_path__ + "static/doener-guel-a4301bd65a6827b550efe8e4b9e85fc3.jpg";